'use strict';

var OwnPropertyKeys = require('es-abstract/helpers/OwnPropertyKeys');

module.exports = function ownKeys(o) {
	return OwnPropertyKeys(o);
};



//////////////////
// WEBPACK FOOTER
// ./~/reflect.ownkeys/implementation.js
// module id = 1021
// module chunks = 2